module.exports = __webpack_public_path__ + "img/icon-warning-thunder-4.a6169e2c.svg";